// Объекты сцены → объекты доски.
import type { Scene } from "@brovka/content-types";
import type { PieceInfo } from "./Board.tsx";

export function piecesFromScene(scene: Scene): PieceInfo[] {
  const out: PieceInfo[] = [];
  for (const o of scene.objects) {
    if (o.type === "player") out.push({ id: o.id, kind: o.team === "us" ? "us" : "them", label: o.label, hero: o.hero, goalkeeper: o.goalkeeper });
    else if (o.type === "ball") out.push({ id: o.id, kind: "ball" });
    else if (o.type === "cone") out.push({ id: o.id, kind: "cone" });
    else if (o.type === "label") out.push({ id: o.id, kind: "label", label: o.text });
  }
  return out;
}

/** Идентификатор мяча сцены. */
export function ballId(scene: Scene): string {
  return scene.objects.find((o) => o.type === "ball")?.id ?? "ball";
}
